import { Tooltip as BaseTooltip } from '@base-ui/react';
import { FC } from 'react';

import { StyledArrow, StyledPopup, StyledPositioner } from './Tooltip.styled';
import type { TooltipProps } from './types';

const Tooltip: FC<TooltipProps> = ({
  title,
  children,
  open,
  disabled,
  side = 'top',
  align = 'center',
  arrow = true,
}) => {
  return (
    <BaseTooltip.Root open={open} disabled={disabled || !title}>
      <BaseTooltip.Trigger render={children} delay={0} />
      {Boolean(title) && (
        <BaseTooltip.Portal>
          <StyledPositioner side={side} align={align} sideOffset={8}>
            <StyledPopup>
              {title}
              {arrow && (
                <StyledArrow>
                  <svg
                    width="12"
                    height="5"
                    viewBox="0 0 12 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.38117 4.44532L0 0H11.5L6.69426 4.41106C6.32647 4.74865 5.76606 4.76326 5.38117 4.44532Z"
                      fill="currentColor"
                    />
                  </svg>
                </StyledArrow>
              )}
            </StyledPopup>
          </StyledPositioner>
        </BaseTooltip.Portal>
      )}
    </BaseTooltip.Root>
  );
};

export default Tooltip;

Tooltip.displayName = 'Tooltip';
